import { Trash2 } from 'lucide-react';

import { DetailsTable } from '@@/DetailsTable';
import { Button } from '@@/buttons';

export function AllowListTable({
  entries: entries,
  isLoading,
  onDelete,
}: {
  entries: string[];
  isLoading: boolean;
  onDelete: (entry: string) => void;
}) {
  return (
    <DetailsTable
      headers={['Entry', '']}
      className="table-hover"
      emptyMessage="No entries in allow list."
      dataCy="allowlist-table"
    >
      {entries.map((entry, index) => (
        <DetailsTable.Row
          key={index}
          label={entry}
          columns={[
            <Button
              color="danger"
              key={`remove-${index}`}
              data-cy={`allowlist-remove-entry-button-${index}`}
              size="xsmall"
              icon={Trash2}
              onClick={() => onDelete(entry)}
              disabled={isLoading}
            >
              Remove
            </Button>,
          ]}
        >
          {null}
        </DetailsTable.Row>
      ))}
    </DetailsTable>
  );
}
